import { render, staticRenderFns } from "./StudentMarksCalendar.vue?vue&type=template&id=4905d257&xmlns%3Av-slot=http%3A%2F%2Fwww.w3.org%2F1999%2FXSL%2FTransform"
import script from "./StudentMarksCalendar.vue?vue&type=script&lang=js"
export * from "./StudentMarksCalendar.vue?vue&type=script&lang=js"
import style0 from "./StudentMarksCalendar.vue?vue&type=style&index=0&id=4905d257&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports